import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Table } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class MissingFromAPITable extends PureComponent {
    render() {
        const { recordsMissingFromAPI } = this.props;

        return (
            <div>
                <div className={ style.dataHeader }>Missing From Affiliate API (Inactive)</div>
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Cell>AFFILIATE TYPE</Table.Cell>
                            <Table.Cell>ADVERTISER ID</Table.Cell>
                            <Table.Cell>ADVERTISER NAME</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        { recordsMissingFromAPI &&
                            recordsMissingFromAPI.map( ( record, index ) => {
                                return (
                                    <Table.Row key={`${ record.affiliate }-${ record.advertiserId }-${index}`}>
                                        <Table.Cell>{ record.affiliate }</Table.Cell>
                                        <Table.Cell>{ record.advertiserId }</Table.Cell>
                                        <Table.Cell>{ record.advertiserName }</Table.Cell>
                                    </Table.Row>
                                );
                            } )
                        }
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default connect()( MissingFromAPITable );
